/** Resolve finding subjects (fact type + id) to record labels from the kernel read model. */
import { factTypes } from "@kit/spines";
import { kernel } from "./api";

export async function labelsFor(subjects: Array<{ type: string; id: string }>): Promise<Record<string, string>> {
  const types = [...new Set(subjects.map((s) => factTypes[s.type]?.slug ?? s.type))];
  const out: Record<string, string> = {};
  await Promise.all(types.map(async (t) => {
    const r = await kernel<{ entities: Array<{ entity_id: string; label: string }> }>(`/entities?type=${encodeURIComponent(t)}&limit=500`).catch(() => ({ entities: [] }));
    for (const e of r.entities) out[e.entity_id] = e.label;
  }));
  return out;
}
